export default __webpack_public_path__ + "static/media/screen_chat_gpt_3.5865927c.png";